
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IOperationLogParams, IOperationLogItem } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 *  系统管理-操作日志列表
 *  @param params 查询参数
 */
export async function queryOperationLogList(params: IOperationLogParams) {
  let data = [] as IOperationLogItem[];
  let total = 0;

  try {
    const { code, context, message } = await Http.get<{data: IOperationLogItem[];total: number}>(
      `${hostUrl}/infra-center/operation-log/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IOperationLogItem[]; total: number };

      data = items || [];
      total = all || 0;
      return {
        data,
        total,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 *  系统管理-操作日志导出
 *  @param params 查询参数
 */
export async function exportOperationLogList(params: IOperationLogParams) {
  let buffer = null as Blob | null;

  try {
    const { code, context, message } = await Http.get<Blob>(
      `${hostUrl}/infra-center/operation-log/export`,
      params,
      { responseType: 'blob' },
    );

    if (code === EAxiosResponseCode.Succeed) {
      buffer = context;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return buffer;
}